module.exports = __webpack_public_path__ + "img/local_convenience_store.04db8b02.svg";